export { default } from './academy-sitemap'
